export const WALLET_CONNECT = 'WALLET_CONNECT';

